import React, { useEffect } from "react";
import { useState } from "react";
import { InputType } from "../..";

export interface BasicInputProps {
  value?: string | number;
  className?: string;
  onChange?: (value: string | number) => void;
  type?: InputType;
  disabled?: boolean;
  onBlur?: (value: any) => void;
}

export const BasicInput = (props: any) => {
  const { value, className, onChange, type, disabled, onBlur } = props;

  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }
  , [value]);

  return (
    <input
      className={className}
      onChange={(e) => {
        setInputValue(e.target.value);
        if (onChange) {
          if(type == InputType.NUMBER){
            console.log('A HACER EL ONCHANGE', e.target.value, 'convertido a float', parseFloat(e.target.value));
            onChange(parseFloat(e.target.value));
          }else{
            onChange(e.target.value);
          }
        }
      }}
      value={inputValue == null ? '' : inputValue}
      type={type}
      disabled={disabled}
      onBlur={onBlur}
    />
  );
};
